import axios from "axios";

export const getEncUrl=async(data)=>{
    const url=`${process.env.REACT_APP_API_URL}/oman-payment-detail?${data}`
    return axios.get(url).then((res)=>{
        return res.data
    })
}